import * as React from 'react';

import { StateStandardInterface, StateStandardsFrameworkInterface, } from './interfaces';

import {
  EXTRA_SMALL_ICON_BASE_SRC,
  SMALL_ICON_BASE_SRC,
  Tooltip,
} from '../../../../Shared/index';
import { SkillCategoryInterface } from '../skills_report/interfaces';

const fileDocumentImgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/file-document.svg`;
const pencilImgSrc = `${SMALL_ICON_BASE_SRC}/pencil.svg`
const arrowDownImgSrc = `${EXTRA_SMALL_ICON_BASE_SRC}/arrow-down.svg`

interface StandardsReportHeaderProps {
  byStudent: boolean;
  selectedStateStandard?: StateStandardInterface | undefined;
  setShowMomentumScoreGoalModal: (show: boolean) => void;
  setShowReportStandardsModal: (show: boolean) => void;
  selectedStateStandardsFramework: StateStandardsFrameworkInterface;
  selectedSkillCategory: SkillCategoryInterface;
  title: string;
}

const forwardSlash = <span className="forward-slash"> / </span>

const StandardsReportHeader: React.FC<StandardsReportHeaderProps> = ({
  byStudent,
  selectedSkillCategory,
  selectedStateStandard,
  selectedStateStandardsFramework,
  setShowMomentumScoreGoalModal,
  setShowReportStandardsModal,
  title
}) => {
  function handleClickChangeGoal() {
    setShowMomentumScoreGoalModal(true)
  }

  function handleClickDownload() {
    window.print()
  }

  function handleClickShowReportStandardsModal() {
    setShowReportStandardsModal(true)
  }

  return (
    <header>
      <h1>
        <b>Standards Report</b>
        {forwardSlash}
        {title}
        {forwardSlash}
        {byStudent ? 'By Student' : 'By Standard'}
        {byStudent && selectedStateStandard ? (
          <React.Fragment>
            {forwardSlash}
            <Tooltip
              tooltipText={selectedStateStandard.description}
              tooltipTriggerText={selectedStateStandard.code}
            />
          </React.Fragment>
        ) : null}
        {!byStudent && selectedSkillCategory ? <React.Fragment>{forwardSlash}{selectedSkillCategory.name}</React.Fragment> : null}
        <span className="button-spacer" />
        <Tooltip
          tooltipText={`This report is aligned to ${selectedStateStandardsFramework.name}. Click to change.`}
          tooltipTriggerText={(
            <button className="quill-button outlined green extra-small focus-on-light" onClick={handleClickShowReportStandardsModal} type="button">{selectedStateStandardsFramework?.abbreviation}</button>
          )}
        />
      </h1>
      <div className="links">
        <a className="quill-button outlined small grey focus-on-light" href='https://support.quill.org/en/articles/13289285-new-standards-report' rel="noopener noreferrer" target="_blank">
          <img alt="" src={fileDocumentImgSrc} />
          Guide
        </a>
        <button className="quill-button outlined small grey focus-on-light" onClick={handleClickChangeGoal} type="button">
          <img alt="" src={pencilImgSrc} />
          Change goal
        </button>
        <button className="quill-button outlined small grey focus-on-light" onClick={handleClickDownload} type="button">
          <img alt="" src={arrowDownImgSrc} />
          Download
        </button>
      </div>
    </header>
  );
};

export default StandardsReportHeader;
